import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"
import { useTranslation } from 'react-i18next';
import HeaderOfPage from '../tools/headerOfPage';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import CountrySelector from './CountrySelector';
import ImageUploaders from '../tools/uploaderimages';

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

export default function EditTestimonialDetail() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    let cookie = getCookies();
    let { Id } = useParams();
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const [tagInput, setTagInput] = useState<string>('');
    const languages = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    const [data, setData] = useState<any>(null);
    const [saving, setSaving] = useState<boolean>(false);
    const [groups, setGroups] = useState<any[]>([]);
    
    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/testimonialdetail/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Testimonial updated successfully'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error updating testimonial'),
            });
        } finally {
            setSaving(false);
        }
    }
    
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/testimonialdetail/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                if (typeof loadedData.title === 'string' || !loadedData.title) {
                    loadedData.title = loadedData.title ? { ku: loadedData.title, fa: loadedData.title, en: loadedData.title, ar: loadedData.title, tr: loadedData.title } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.title && loadedData.title.nl) {
                    loadedData.title.ku = loadedData.title.nl;
                    delete loadedData.title.nl;
                    if (!loadedData.title.tr) loadedData.title.tr = '';
                }
                if (typeof loadedData.description === 'string' || !loadedData.description) {
                    loadedData.description = loadedData.description ? { ku: loadedData.description, fa: loadedData.description, en: loadedData.description, ar: loadedData.description, tr: loadedData.description } : { ku: '', fa: '', en: '', ar: '', tr: '' };
                } else if (loadedData.description && loadedData.description.nl) {
                    loadedData.description.ku = loadedData.description.nl;
                    delete loadedData.description.nl;
                    if (!loadedData.description.tr) loadedData.description.tr = '';
                }
                // Ensure tags structure
                if (!loadedData.tags || typeof loadedData.tags !== 'object') {
                    loadedData.tags = { ku: [], fa: [], en: [], ar: [], tr: [] };
                } else {
                    ['ku', 'fa', 'en', 'ar', 'tr'].forEach(lang => {
                        if (!Array.isArray(loadedData.tags[lang])) {
                            loadedData.tags[lang] = [];
                        }
                    });
                }
                // Format date
                if (loadedData.date) {
                    const date = new Date(loadedData.date);
                    loadedData.date = date.toISOString().split('T')[0];
                } else {
                    loadedData.date = new Date().toISOString().split('T')[0];
                }
            }
            setData(loadedData)
        } catch (error) {
            setError(error);
        }
    }

    const loadGroups = async () => {
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/testimonialgroup/all',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setGroups(res.data.message || []);
        } catch (error) {
            console.error('Error loading groups:', error);
        }
    }
    
    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";
    
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Testimonial',
            url: '/dashboard/Feature'
        },
        {
            name: 'Group List',
            url: '/dashboard/Testimonial/GroupList'
        },
        {
            name: 'Edit Testimonial',
            url: null
        }
    ]

    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    const addTag = () => {
        if (tagInput.trim() && !data.tags[activeLang].includes(tagInput.trim())) {
            setData({
                ...data,
                tags: {
                    ...data.tags,
                    [activeLang]: [...data.tags[activeLang], tagInput.trim()]
                }
            });
            setTagInput('');
        }
    };

    const removeTag = (tag: string) => {
        setData({
            ...data,
            tags: {
                ...data.tags,
                [activeLang]: data.tags[activeLang].filter((t: string) => t !== tag)
            }
        });
    };
    
    useEffect(() => {
        load();
        loadGroups();
    }, []);
    
    if (!data) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Edit Testimonial"></HeaderOfPage>
                <div className="bg-white rounded-xl shadow-sm p-8 mt-6">
                    <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                    <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
                </div>
            </div>
        );
    }
    
    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="Edit Testimonial"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden" dir='rtl'>
                        <div className="p-6 space-y-6">
                            <form key={key} className='flex flex-col gap-4'>
                                {/* Language Selector */}
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {t('Language')}
                                    </label>
                                    <div className="flex gap-2">
                                        {languages.map((lang) => (
                                            <button
                                                key={lang.code}
                                                type="button"
                                                onClick={() => setActiveLang(lang.code)}
                                                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                                    activeLang === lang.code
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                }`}
                                            >
                                                {lang.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Parent Group')}
                                    </label>
                                    <select
                                        value={data.parent?._id || data.parent || ''}
                                        onChange={(e) => setData({ ...data, parent: e.target.value })}
                                        className={inputstyle}
                                    >
                                        <option value="">{t('Select Group')}</option>
                                        {groups.map((group: any) => (
                                            <option key={group._id || group.id} value={group._id || group.id}>
                                                {getDisplayName(group.title)}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Title')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        value={data.title?.[activeLang] || ''}
                                        type="text"
                                        className={`${inputstyle} ${error != null && error['title'] != undefined && 'bg-red-100 border-red-300'} `}
                                        placeholder={t('Enter title')}
                                        onChange={(e) => {
                                            setData({ 
                                                ...data, 
                                                title: { 
                                                    ...data.title, 
                                                    [activeLang]: e.target.value 
                                                }
                                            });
                                        }}
                                    />
                                    {error != null && error['title'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['title']['message']}</small>}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                                    </label>
                                    <textarea
                                        value={data.description?.[activeLang] || ''}
                                        rows={4}
                                        className={inputstyle}
                                        placeholder={t('Enter description')}
                                        onChange={(e) => {
                                            setData({ 
                                                ...data, 
                                                description: { 
                                                    ...data.description, 
                                                    [activeLang]: e.target.value 
                                                }
                                            });
                                        }}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Country')}
                                    </label>
                                    <CountrySelector
                                        value={data.country || ''}
                                        onChange={(value) => setData({ ...data, country: value })}
                                        placeholder={t('Select country')}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Date')}
                                    </label>
                                    <input
                                        type="date"
                                        value={data.date || ''}
                                        className={inputstyle}
                                        onChange={(e) => setData({ ...data, date: e.target.value })}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Tags')} ({languages.find(l => l.code === activeLang)?.label})
                                    </label>
                                    <div className="flex gap-2 mb-2">
                                        <input
                                            type="text"
                                            value={tagInput}
                                            className={inputstyle}
                                            placeholder={t('Enter tag and press Enter')}
                                            onChange={(e) => setTagInput(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    addTag();
                                                }
                                            }}
                                        />
                                        <button
                                            type="button"
                                            onClick={addTag}
                                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                                        >
                                            {t('Add')}
                                        </button>
                                    </div>
                                    <div className="flex flex-wrap gap-2">
                                        {data.tags && data.tags[activeLang] && data.tags[activeLang].map((tag: string, index: number) => (
                                            <span
                                                key={index}
                                                className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
                                            >
                                                {tag}
                                                <button
                                                    type="button"
                                                    onClick={() => removeTag(tag)}
                                                    className="text-blue-600 hover:text-blue-800"
                                                >
                                                    ×
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                </div>

                                <div className="flex items-center gap-4">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="checkbox"
                                            checked={data.publish !== false}
                                            onChange={(e) => setData({ ...data, publish: e.target.checked })}
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <span className="text-sm text-gray-700">{t('Publish')}</span>
                                    </label>
                                </div>

                                <div className="flex gap-4 pt-4">
                                    <button
                                        type="button"
                                        onClick={save}
                                        disabled={saving}
                                        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                    >
                                        {saving ? t('Saving...') : t('Save')}
                                    </button>
                                </div>
                            </form>
                            <ImageUploaders count={1000} id={data.id} component={'testimonialdetail'}></ImageUploaders>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

